module.exports = __webpack_public_path__ + "static/media/marker.0ada8fb7.svg";